"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BoxPositionSizes = exports.BoxPositionPositions = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sizeMap = {
  auto: "auto",
  none: "",
  zero: 0,
  mini: _AppTheme.default.spacing(1),
  small: _AppTheme.default.spacing(1.5),
  medium: _AppTheme.default.spacing(2),
  large: _AppTheme.default.spacing(2.5),
  xl: _AppTheme.default.spacing(3),
  xxl: _AppTheme.default.spacing(4),
  nMini: -_AppTheme.default.spacing(1),
  nSmall: -_AppTheme.default.spacing(1.5),
  nMedium: -_AppTheme.default.spacing(2),
  nLarge: -_AppTheme.default.spacing(2.5),
  nXl: -_AppTheme.default.spacing(3),
  nXxl: -_AppTheme.default.spacing(4)
};

var BoxPosition = function BoxPosition(_ref) {
  var position = _ref.position,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: position,
    top: sizeMap[top],
    bottom: sizeMap[bottom],
    left: sizeMap[left],
    right: sizeMap[right]
  }, children);
};

BoxPosition.propTypes = {
  position: _propTypes.default.oneOf(["static", "relative", "absolute", "sticky", "fixed"]),
  top: _propTypes.default.oneOf(["auto", "none", "zero", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),
  bottom: _propTypes.default.oneOf(["auto", "none", "zero", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),
  left: _propTypes.default.oneOf(["auto", "none", "zero", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),
  right: _propTypes.default.oneOf(["auto", "none", "zero", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"]),
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BoxPosition.defaultProps = {
  position: "static",
  top: "none",
  bottom: "none",
  left: "none",
  right: "none",
  children: null
};
var BoxPositionPositions = ["static", "relative", "absolute", "sticky", "fixed"];
exports.BoxPositionPositions = BoxPositionPositions;
var BoxPositionSizes = ["auto", "none", "zero", "mini", "small", "medium", "large", "xl", "xxl", "nMini", "nSmall", "nMedium", "nLarge", "nXl", "nXxl"];
exports.BoxPositionSizes = BoxPositionSizes;
var _default = BoxPosition;
exports.default = _default;